import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { GET_CLIENT_DETAIL, GET_WORKING_HOUR_DATA, PAY_CYCLE_BY_CLIENT_ID, SAVE_WORKING_HOURS_V2 } from "../../config/ApiConstant";
import { getTwoDetails, getTwoFilteredDetails, postAllData } from "../../service/ProductService";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { formatDate } from "../../appconfig/AppHelper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { SkeletonbodyTemplate, Skeletonitems } from "../../appconfig/Settings";
import SalaryPreviewVersion2Client from "../../components/SalaryPreviewSidebar/SalaryPreviewVersion2";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { EmployeeAdditionalPayGrid, EmployeeWageGrid } from "../../config/CommonComponent";

const AddWorkingHours = () => {
  document.title = "Working Hour | Nexawage Payroll";
  const toast = useRef<any>(null);

  // screen width
  const isMobile = window.innerWidth <= 490;

  // get userData from local Storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const location = useLocation();
  const { payCycleId, clientId }: any = useParams();

  let paycycle_id: string | null = null;
  let client_id: string | null = null;

  // states for paycycle dropdown
  const [payCycleOptions, setPayCycleOptions] = useState<any[]>([]);

  // storing paycle if initially from local strage and on changing dropdown it select dropdown id
  const [selectedPayCycleId, setSelectedPayCycleId] = useState<number | null>(
    localStorage.getItem("pay_cycle_id") ? Number(localStorage.getItem("pay_cycle_id")) : null,
  );

  const directPath = location.pathname.startsWith("/pay-cycle/working-hours/");
  const payCycle_current = Number(localStorage.getItem("pay_cycle_id")) ?? null;

  if (location.pathname.startsWith("/report/run-payroll/")) {
    // Use IDs from userData
    paycycle_id = selectedPayCycleId ? String(selectedPayCycleId) : null;

    client_id = userData?.id ?? null;
  } else {
    // Use IDs from params (decode if base64)
    paycycle_id = payCycleId
      ? (() => {
        try {
          return atob(payCycleId);
        } catch {
          return null;
        }
      })()
      : null;

    client_id = clientId
      ? (() => {
        try {
          return atob(clientId);
        } catch {
          return null;
        }
      })()
      : null;
  }

  const [employeeData, setEmployeeData] = useState<any>([]);
  const [employeeDataPreview, setEmployeeDataPreview] = useState<any>([]);
  const [employeeDataListPreview, setEmployeeDataListPreview] = useState<any>([]);

  const [clientData, setClientData] = useState<any>([]);
  const [globalHours, setGlobalHours] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<any>({});
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [disableBtn, setDisableBtn] = useState<boolean>(false);

  const [timePeriod, setTimePeriod] = useState<any>({});
  const [previewVisibleVersion2, setPreviewVisibleVersion2] = useState<boolean>(false);

  // current year
  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);

  // add employee working hour dialog for mobile
  const [addWorkingHourEmployeeDialog, setAddWorkingHourEmployeeDialog] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [activeTabIndex, setActiveTabIndex] = useState<any>(0);

  // set initial data of employee to compare value
  const [initialEmployeeData, setInitialEmployeeData] = useState<any>({});
  const navigate = useNavigate();
  const userRole = userData?.roles?.role_name || "";

  useEffect(() => {
    if (userData?.id) {
      fetchClientDetail();
      fetchPayCycle();
    }
  }, [userData?.id, location.pathname, selectedPayCycleId, selectedYear]);

  // client details employee fetch api call
  const fetchClientDetail = async () => {
    setLoading(true);
    try {
      const response = await getTwoDetails(GET_CLIENT_DETAIL, "paycycleId", paycycle_id, "clientId", client_id);

      // set time period in state for show start date and end date or button enable disable condition using this time period state
      setTimePeriod({
        status: response?.paystub_generated,
        start_date: response?.start_date,
        end_date: response?.end_date,
        payCheckDate: response?.pay_check_date,
        client_charge: response?.client_charge,
        is_edit: response?.is_edit,
        holiday_status: response?.general_holiday_Status,
        payment_status: response?.payment_status,
      });

      // Only include employees where show_emp === true
      const employees = (response?.client?.employee || []).filter((emp: any) => emp?.show_emp === true);
      const clientData = response?.client;
      setClientData(clientData);
      setEmployeeData(employees);

      // set initial data as blank object
      const initialData: any = {};

      // set data for each employee in initial obj and dafault value set
      employees.forEach((emp: any) => {
        // condition to check stat holiday available and if how much
        let holiday_hour = 0;
        // if isEdit & genereal holiday available then display start holiday comming from api
        if (response?.is_edit && emp?.holiday_hour) {
          holiday_hour = emp?.holiday_hour;
          // ckeck specific employee wise that if pay_stat_holiday is checked then emp holiday count * 8 else 0 will display
        } else if (emp?.holiday_status === 1) {
          // holiday_hour = emp?.holidayCount * 8;
          holiday_hour = 0;
        }

        // initial data of employee
        initialData[emp.id] = {
          wage: emp?.wage ?? 0,
          hourly_Salary: emp?.wage ?? 0,
          working_hour: emp?.hour ?? 0,
          holiday_hour: holiday_hour,
          vacation_payout: emp?.manual_vacation_payout === true ? emp?.vacation_payout : 0,
          // vacation_payout: emp?.vacation_payout ?? 0,
          bonus: emp?.bonus ?? 0,
          commission: emp?.commission ?? 0,
          medical_exemption: emp?.medical_exemption ?? 0,
          holiday_status: emp?.holiday_status ?? 0,
          state_holiday_value: emp?.state_holiday_value ?? 0,
          state_holiday_percentage: emp?.state_holiday_percentage ?? 1.5,
          overtime_value: emp?.overtime_value ?? 0,
          overtime: emp?.overtime ?? 0,
          overtime_2: emp?.overtime_2 ?? 0,
          holiday_Salary: emp?.holiday_Salary ?? 0,
          stat_holiday: emp?.stat_holiday ?? 0,
          overtime_percentage: emp?.overtime_percentage ?? 1.5,
          overtime_2_multiplier: emp?.overtime_2_multiplier ?? 2,
          overtime_2_value: emp?.overtime_2_value ?? 0,
          tip: emp?.tip ?? 0,
          paid_federal_tax: emp?.paid_federal_tax ?? 0,
          paid_provincial_tax: emp?.paid_provincial_tax ?? 0,
          provincial_tax: emp?.provincial_tax ?? 0,
          federal_tax: emp?.provincial_tax ?? 0,
          manual_vacation_payout: emp?.manual_vacation_payout,
          is_salary: emp?.is_salary,

          // night values
          night_wage: emp?.wage_night ?? 0,
          night_hours: emp?.night_hours ?? 0,
          stat_working_night_value: emp?.stat_working_night_value ?? 0,
          holiday_night_hour: emp?.holiday_night_hour ?? 0,
          overtime_night_value: emp?.overtime_night_value ?? 0,
          overtime_2_night_value: emp?.overtime_2_night_value ?? 0,
        };
      });

      setGlobalHours(initialData);
      setInitialEmployeeData(initialData);
      setEmployeeDataPreview(initialData);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setLoading(false);
    }
  };

  // api to fetch paycycle
  const fetchPayCycle = async () => {
    try {
      let clientId;
      if (userRole === "Client") {
        clientId = userData?.id;
      } else if (userRole === "User" || userRole === "Admin") {
        clientId = client_id;
      }

      if (!clientId) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Client id is missing",
        });
        return;
      }

      const response = await getTwoFilteredDetails(PAY_CYCLE_BY_CLIENT_ID, "id", clientId, "year", selectedYear);

      const data = response.payCycleList;

      const cycles = data.map((cycle: any) => ({
        label: `${formatDate(cycle.starting_date)} - ${formatDate(cycle.ending_date)}`,
        value: cycle.id,
      }));

      setPayCycleOptions(cycles || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      // setPageLoad(false);
    }
  };

  // handle input values
  const handleInputChange = (e: any, empId: any, field: string) => {
    const value = e.target.value;
    setGlobalHours({
      ...globalHours,
      [empId]: {
        ...globalHours[empId],
        [field]: value,
      },
    });

    if (field === "working_hour") {
      setErrors({ ...errors, [empId]: "" });
    }
  };

  // employee hours submit api call
  const submitOrPreviewPaystub = async (type: any, edited_tax_arr: any = null) => {
    try {
      // btn click for preview or submit
      let apiRequesturl;
      if (type === "submit") {
        setSubmitLoading(true);
        apiRequesturl = SAVE_WORKING_HOURS_V2;
      } else {
        setPreviewLoading(true);
        apiRequesturl = GET_WORKING_HOUR_DATA;
      }
      setDisableBtn(true);

      // setting up payload for each employee
      let employee_hour = setEmployeeWorkingHourRequestData();

      //Check Inner Preview Page Taxes Updated
      if (edited_tax_arr != null && edited_tax_arr != undefined) {
        // Using forEach
        employee_hour.forEach((items, key) => {
          let userId = items.user_id;
          let federalUpdated = Number(edited_tax_arr[userId]?.federal_tax);
          let provincialUpdated = Number(edited_tax_arr[userId]?.provincial_tax);
          let federalOriginal = Number(items.paid_federal_tax ?? 0);
          let provincialOriginal = Number(items.paid_provincial_tax ?? 0);

          //check value updated or not
          if (items.edited != true) {
            if (federalUpdated != federalOriginal || provincialUpdated != provincialOriginal) {
              items.edited = true;
            }
          }

          items.front_paid_federal_tax = edited_tax_arr[userId]?.federal_tax;
          items.front_paid_provincial_tax = edited_tax_arr[userId]?.provincial_tax;
        });
      }

      // checking is_edit is true or not if true then set it 1 or false to 0
      const is_edit = timePeriod.is_edit === 1 ? 1 : 0;

      // payload set
      const payload = {
        is_edit,
        employee_hour,
        pay_cycle_id: paycycle_id,
        client_id: client_id,
      };


      const response = await postAllData(apiRequesturl, payload);
      if (response) {
        if (type === "submit") {
          if (userRole === "Client") {
            // update sessionStorage & state
            localStorage.setItem("pay_cycle_id", response?.data);
          }

          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: response?.message,
          });

          setTimeout(() => {
            if (userRole === "Client") {
              navigate("/paystub");
            } else {
              // navigate(`/pay-cycle/${client_id}`);
              const safeClientId = client_id ?? "";
              navigate(`/pd7a-report/${btoa(safeClientId)}`);
            }
          }, 1000);
        } else {
          setEmployeeDataListPreview(response?.data);
          hanldePreviewSidebar();
        }
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setSubmitLoading(false);
      setDisableBtn(false);
      setPreviewLoading(false);
    }
  };

  // setEmployeeData for API request
  const setEmployeeWorkingHourRequestData = () => {
    // create object for working hour data and set into object for each employee id wise
    const workingHoursData: any = {};
    Object.keys(globalHours).forEach((id) => {
      workingHoursData[id] = globalHours[id].working_hour;
    });

    //Set Employee Hours
    const employee_hour = Object.keys(globalHours).map((empId) => {
      // variable to store values after changes made
      const current = globalHours[empId];

      // variable to store values commming from api
      const original = initialEmployeeData[empId];

      // responseobj for initial submit
      let responseObj: any = {
        user_id: Number(empId),
        hour: Number(current?.working_hour ?? 0).toFixed(2),
        bonus: Number(current?.bonus ?? 0).toFixed(2),
        vacation_payout: Number(current?.vacation_payout ?? 0).toFixed(2),
        wage: Number(current?.wage ?? 0).toFixed(2),
        hourly_Salary: Number(current?.wage ?? 0).toFixed(2),
        commission: Number(current?.commission ?? 0).toFixed(2),
        medical_exemption: Number(current?.medical_exemption ?? 0).toFixed(2),
        state_holiday_percentage: Number(current?.state_holiday_percentage ?? 0).toFixed(2),
        is_salary: current?.is_salary,
        ...(current.is_salary === true ? {
          holiday_Salary: Number(current?.holiday_Salary ?? 0).toFixed(2),
          overtime: Number(current?.overtime ?? 0).toFixed(2),
          overtime_2: Number(current?.overtime_2 ?? 0).toFixed(2),
          stat_holiday: Number(current?.stat_holiday ?? 0).toFixed(2),
        } : {
          state_holiday_value: Number(current?.state_holiday_value ?? 0).toFixed(2),
          holiday_hour: Number(current?.holiday_hour ?? 0).toFixed(2),
          overtime_value: Number(current?.overtime_value ?? 0).toFixed(2),
          overtime_2_value: Number(current?.overtime_2_value ?? 0).toFixed(2),
        }),
        overtime_percentage: Number(current?.overtime_percentage ?? 0).toFixed(2),
        overtime_2_multiplier: Number(current?.overtime_2_multiplier ?? 0).toFixed(2),
        tip: Number(current?.tip ?? 0).toFixed(2),

        // night values
        ...(current.night_hours == "0.00" || current.night_hours == null
          ? {
            night_wage: "0.00",
            night_hours: "0.00",
            overtime_2_night_value: "0.00",
            overtime_night_value: "0.00",
            holiday_night_hour: "0.00",
            stat_working_night_value: "0.00",
          }
          : {
            night_wage: Number(current?.night_wage ?? 0).toFixed(2),
            night_hours: Number(current?.night_hours ?? 0).toFixed(2),
            overtime_2_night_value: Number(current?.overtime_2_night_value ?? 0).toFixed(2),
            overtime_night_value: Number(current?.overtime_night_value ?? 0).toFixed(2),
            holiday_night_hour: Number(current?.holiday_night_hour ?? 0).toFixed(2),
            stat_working_night_value: Number(current?.stat_working_night_value ?? 0).toFixed(2),
          }),
      };

      // requestobj for edittime or update
      if (timePeriod?.is_edit === 1) {
        responseObj["edited"] = false;

        const isEdited =
          current.working_hour != original.working_hour ||
          current.holiday_hour != original.holiday_hour ||
          current.bonus != original.bonus ||
          current.vacation_payout != original.vacation_payout ||
          current.wage != original.wage ||
          current.commission != original.commission ||
          current.medical_exemption != original.medical_exemption ||
          current.state_holiday_value != original.state_holiday_value ||
          current.state_holiday_percentage != original.state_holiday_percentage ||
          current.overtime_value != original.overtime_value ||
          current.overtime != original.overtime ||
          current.overtime_2 != original.overtime_2 ||
          current.holiday_Salary != original.holiday_Salary ||
          current.stat_holiday != original.stat_holiday ||
          current.overtime_percentage != original.overtime_percentage ||
          current.overtime_2_multiplier != original.overtime_2_multiplier ||
          current.overtime_2_value != original.overtime_2_value ||
          current.tip != original.tip ||
          current.night_wage != original.night_wage ||
          current.night_hours != original.night_hours ||
          current.stat_working_night_value != original.stat_working_night_value ||
          current.holiday_night_hour != original.holiday_night_hour ||
          current.overtime_night_value != original.overtime_night_value ||
          current.overtime_2_night_value != original.overtime_2_night_value;

        if (isEdited) {
          responseObj = {
            user_id: Number(empId),
            hour: Number(current?.working_hour ?? 0).toFixed(2),
            bonus: Number(current?.bonus ?? 0).toFixed(2),
            // vacation_payout:
            //   current?.manual_vacation_payout === false
            //     ? Number(0).toFixed(2)
            //     : Number(current?.vacation_payout ?? 0).toFixed(2),
            vacation_payout: Number(current?.vacation_payout ?? 0).toFixed(2),
            wage: Number(current?.wage ?? 0).toFixed(2),
            hourly_Salary: Number(current?.wage ?? 0).toFixed(2),
            commission: Number(current?.commission ?? 0).toFixed(2),
            medical_exemption: Number(current?.medical_exemption ?? 0).toFixed(2),
            state_holiday_percentage: Number(current?.state_holiday_percentage ?? 0).toFixed(2),
            is_salary: current?.is_salary,
            ...(current.is_salary === true ? {
              holiday_Salary: Number(current?.holiday_Salary ?? 0).toFixed(2),
              overtime: Number(current?.overtime ?? 0).toFixed(2),
              overtime_2: Number(current?.overtime_2 ?? 0).toFixed(2),
              stat_holiday: Number(current?.stat_holiday ?? 0).toFixed(2),
            } : {
              state_holiday_value: Number(current?.state_holiday_value ?? 0).toFixed(2),
              holiday_hour: Number(current?.holiday_hour ?? 0).toFixed(2),
              overtime_value: Number(current?.overtime_value ?? 0).toFixed(2),
              overtime_2_value: Number(current?.overtime_2_value ?? 0).toFixed(2),
            }),
            overtime_percentage: Number(current?.overtime_percentage ?? 0).toFixed(2),
            overtime_2_multiplier: Number(current?.overtime_2_multiplier ?? 0).toFixed(2),
            tip: Number(current?.tip ?? 0).toFixed(2),
            edited: true,

            // night values
            ...(current.night_hours == "0.00" || current.night_hours == null
              ? {
                night_wage: "0.00",
                night_hours: "0.00",
                overtime_2_night_value: "0.00",
                overtime_night_value: "0.00",
                holiday_night_hour: "0.00",
                stat_working_night_value: "0.00",
              }
              : {
                night_wage: Number(current?.night_wage ?? 0).toFixed(2),
                night_hours: Number(current?.night_hours ?? 0).toFixed(2),
                overtime_2_night_value: Number(current?.overtime_2_night_value ?? 0).toFixed(2),
                overtime_night_value: Number(current?.overtime_night_value ?? 0).toFixed(2),
                holiday_night_hour: Number(current?.holiday_night_hour ?? 0).toFixed(2),
                stat_working_night_value: Number(current?.stat_working_night_value ?? 0).toFixed(2),
              }),
          };
        }

        responseObj.paid_federal_tax = Number(original?.paid_federal_tax ?? 0).toFixed(2);
        responseObj.paid_provincial_tax = Number(original?.paid_provincial_tax ?? 0).toFixed(2);
        responseObj.federal_tax = Number(original?.federal_tax ?? 0).toFixed(2);
        responseObj.provincial_tax = Number(original?.provincial_tax ?? 0).toFixed(2);
      }

      return responseObj;
    });

    return employee_hour;
  };

  // Checks if an element can receive focus
  const isFocusableInput = (el: Element | null): el is HTMLInputElement => {
    return el instanceof HTMLInputElement && !el.disabled && !el.hasAttribute("aria-disabled");
  };

  // Find next cell to navigate in table
  const findNextEnabled = (startRow: number, startCol: string, rowStep: number, colStep: number) => {
    let row = startRow;
    let col = startCol;

    while (true) {
      // Move vertically
      if (rowStep !== 0) row += rowStep;

      // Move horizontally
      if (colStep !== 0) {
        // Get all columns in the current row
        const fields = Array.from(document.querySelectorAll<HTMLInputElement>(`input[data-row="${startRow}"]`)).map((i) => i.dataset.col!);

        const colIndex = fields.indexOf(col);
        col = fields[colIndex + colStep];
      }

      // Stop if out of bounds
      if (!col || row < 0) return null;

      // Find the target input
      const candidate = document.querySelector<HTMLInputElement>(`input[data-row="${row}"][data-col="${col}"]`);

      if (!candidate) return null;

      // Skip disabled inputs
      if (isFocusableInput(candidate)) return candidate;
    }
  };

  // Handles arrow-key navigation between input fields
  const handleKeyNavigation = (e: React.KeyboardEvent) => {
    const key = e.key;

    // Only care about arrow keys
    if (!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(key)) return;

    // Stop default InputNumber behavior
    e.preventDefault();
    e.stopPropagation();

    const input = e.target as HTMLInputElement;

    // Read grid position
    const row = Number(input.dataset.row);
    const col = input.dataset.col!;
    if (Number.isNaN(row) || !col) return;

    let target: HTMLInputElement | null = null;

    switch (key) {
      case "ArrowRight":
        target = findNextEnabled(row, col, 0, 1);
        break;
      case "ArrowLeft":
        target = findNextEnabled(row, col, 0, -1);
        break;
      case "ArrowDown":
        target = findNextEnabled(row, col, 1, 0);
        break;
      case "ArrowUp":
        target = findNextEnabled(row, col, -1, 0);
        break;
    }

    // Move focus if a valid input is found
    target?.focus();
  };

  // create input field for each employee
  const renderInputField = (rowData: any, field: string, placeholder: string, rowIndex?: number, isError = false) => {
    const isCurrencyField =
      field === "bonus" ||
      field === "commission" ||
      field === "tip" ||
      field === "medical_exemption" ||
      field === "wage" ||
      field === "overtime" ||
      field === "overtime_2" ||
      field === "holiday_Salary" ||
      field === "stat_holiday" ||
      field === "vacation_payout" ||
      field === "night_wage";
    const percentageField = field === "state_holiday_percentage" || field === "overtime_percentage" || field === "overtime_2_multiplier";
    const rawValue = globalHours[rowData.id]?.[field];
    const value = !window.cn(rawValue) ? Number(rawValue) : null;
    const disableField =
      (field === "vacation_payout" && rowData?.vacation_hold === false) ||
      (field === "vacation_payout" && rowData?.no_vacation_payout === true) ||
      // (field === "working_hour" && rowData?.is_salary === true) ||
      // (field === "holiday_hour" && rowData?.pay_stat_holiday === false) ||
      // (field === "holiday_night_hour" && rowData?.pay_stat_holiday === false) ||
      timePeriod?.payment_status === true;

    return (
      <div>
        <div className="flex-1 p-inputgroup">
          {isCurrencyField && (
            <span className="p-inputgroup-addon" style={{ minWidth: "1rem" }}>
              $
            </span>
          )}
          {percentageField && (
            <span className="p-inputgroup-addon" style={{ minWidth: "1rem" }}>
              *
            </span>
          )}

          <InputNumber
            value={value}
            style={{ minWidth: "50px" }}
            onValueChange={(e) => handleInputChange(e, rowData.id, field)}
            placeholder={placeholder}
            disabled={disableField}
            className={`working-hour-input-field w-full ${isError ? "p-invalid" : ""}`}
            maxFractionDigits={2}
            mode="decimal"
            useGrouping={false}
            inputStyle={{ appearance: "none", MozAppearance: "textfield" }}
            // CAPTURE phase
            onKeyDownCapture={handleKeyNavigation}
            data-row={rowIndex}
            data-col={field}
          />

          {isCurrencyField && <span className="p-inputgroup-addon">CAD</span>}
        </div>

        {isError && <small className="block mt-1 p-error">{errors[rowData.id]}</small>}
      </div>
    );
  };

  // handle sidebar for preview show
  const hanldePreviewSidebar = () => {
    const workingHoursData: any = {};
    Object.keys(globalHours).forEach((id) => {
      workingHoursData[id] = globalHours[id].working_hour;
    });
    setPreviewVisibleVersion2(true);
  };

  // clear all filter
  const clearAll = () => {
    setSelectedPayCycleId(payCycle_current);
    setSelectedYear(currentYear);
  };

  // const leftToolbarTemplate = () => (
  //   <>
  //     <Calendar
  //       value={moment(String(selectedYear), "YYYY").toDate()}
  //       view="year"
  //       dateFormat="yy"
  //       onChange={(e: any) => {
  //         const year = moment(e.value).year();
  //         if (year) setSelectedYear(year);
  //       }}
  //       showIcon
  //       placeholder="Select Year"
  //       className="ml-2 w-11rem"
  //     />
  //   </>
  // );

  const rightToolbarTemplate = () => (
    <>
      {userRole === "Client" && location.pathname.startsWith("/report/run-payroll/") ? (
        <>
          <label className="mr-3 label-text">Select Pay Cycle</label>
          <Dropdown
            value={selectedPayCycleId}
            onChange={(e) => setSelectedPayCycleId(e.value)}
            options={payCycleOptions}
            placeholder="Select Pay Cycle"
            className="mr-2 w-16rem md:mb-0 mb-2"
          />

          <Calendar
            value={moment(String(selectedYear), "YYYY").toDate()}
            view="year"
            dateFormat="yy"
            onChange={(e: any) => {
              const year = moment(e.value).year();
              if (year) setSelectedYear(year);
            }}
            showIcon
            placeholder="Select Year"
            className="mr-2 w-11rem"
          />
          <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="mr-2 p-button-outlined common-p-outline-button" />
        </>
      ) : null}
    </>
  );

  // hide add working hour employee dialog
  const hideAddWorkingHourEmployeeDialog = () => {
    setAddWorkingHourEmployeeDialog(false);
    setActiveTabIndex(0);
  };

  // add & edit employee working hour data
  const addEditEmployeeWorkingHourData = (rowData: any) => {
    setSelectedEmployee(rowData);

    setGlobalHours({
      ...globalHours,
      [rowData.id]: {
        ...globalHours[rowData.id],
      },
    });

    setIsEdit(true);
    setErrors({});
    setAddWorkingHourEmployeeDialog(true);
  };

  // handle change for dialog
  const handleDialogChange = (e: any, field: string) => {
    if (!selectedEmployee) return;

    const value = e.value ?? e.target?.value ?? 0;

    setGlobalHours((prev: any) => ({
      ...prev,
      [selectedEmployee.id]: {
        ...prev[selectedEmployee.id],
        [field]: value,
      },
    }));
  };

  // hide add & edit employee modal
  const hideAddEditEmployeeDialog = () => {
    setAddWorkingHourEmployeeDialog(false);
    setSubmitLoading(false);
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Reports" pageName="Add Working Hours" pageTitle={"Add Working Hours"} goToPage={directPath ? true : false} />
      <div className="grid crud-demo">
        <div className="col-12">
          <div className="card">
            {loading ? (
              <DataTable value={Skeletonitems}>
                <Column field="name" header="Employee Name" body={SkeletonbodyTemplate} />
                <Column field="wage" header="Wage" body={SkeletonbodyTemplate} />
                <Column field="working_hour" header="Working Hours" body={SkeletonbodyTemplate} />
                <Column field="overtime_value " header="OverTime Pay" body={SkeletonbodyTemplate} />
                <Column field="overtime_2_value " header="OverTime Double Pay" body={SkeletonbodyTemplate} />
                <Column field="holiday_hour" header="Stat Holiday" body={SkeletonbodyTemplate} />
                <Column field="state_holiday_value" header="Stat Working Holiday" body={SkeletonbodyTemplate} />
                <Column field="vacation_payout" header="Vacation Payout" body={SkeletonbodyTemplate} />
                <Column field="bonus" header="Bonus" body={SkeletonbodyTemplate} />
                <Column field="commission" header="Commission" body={SkeletonbodyTemplate} />
                <Column field="medical_exemption" header="Health Benefit" body={SkeletonbodyTemplate} />
                <Column field="tip" header="Tips" body={SkeletonbodyTemplate} />
              </DataTable>
            ) : employeeData.length <= 0 ? (
              <div className="text-center">
                <h4>No Employee Found</h4>
              </div>
            ) : !timePeriod.client_charge ? (
              <div className="center-working-hour">
                <h4 className="mb-2 ">
                  Client Payment is pending for this Pay Cycle : {formatDate(timePeriod?.start_date)} to {formatDate(timePeriod?.end_date)}
                </h4>
              </div>
            ) : (
              <>
                <div className="mt-4 mb-5 text-center">
                  {!window.cn(selectedPayCycleId) && (
                    <h4>
                      You are generating paystub report for Time period: {formatDate(timePeriod?.start_date)} to {formatDate(timePeriod?.end_date)}
                    </h4>
                  )}

                  {timePeriod?.payment_status === true && <h3 style={{ color: "green" }}>You have already paid for this Time Period</h3>}
                </div>

                <Toast ref={toast} />
                {userRole === "Client" && location.pathname.startsWith("/report/run-payroll/") ? (
                  <Toolbar
                    className=" working-hour"
                    style={{ padding: "1.2rem" }}
                    // left={leftToolbarTemplate}
                    right={rightToolbarTemplate}
                  />
                ) : null}

                <DataTable
                  value={employeeData}
                  showGridlines
                  dataKey="id"
                  responsiveLayout="scroll"
                  className="datatable-responsive p-datatble-sm"
                  stripedRows
                  removableSort
                  emptyMessage="No Employee Found"
                >
                  <Column
                    field="name"
                    header="Employee Name"
                    body={(rowData) => (
                      <>
                        <div className="flex align-items-center justify-content-center gap-3 ">
                          <div className="">
                            {" "}
                            {rowData.first_name} {rowData.last_name}
                          </div>

                          {rowData.wage_night != null && rowData.wage_night != "0" && (
                            <div className="flex flex-column justify-content-between gap-6">
                              <div>{rowData.wage_night != null && rowData.wage_night != "0" && "(Wage 1)"}</div>
                              <div>{rowData.wage_night != null && rowData.wage_night != "0" && "(Wage 2)"}</div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  />

                  <Column
                    header="Wage"
                    body={(rowData, options) => (
                      <div className="flex flex-column gap-">
                        {/* Day Wage (existing) */}
                        {renderInputField(rowData, "wage", "Day Wage", options.rowIndex)}

                        {/* Night Wage (conditional) */}
                        {rowData?.wage_night != null && rowData.wage_night != "0" && (
                          <>
                            <hr />
                            <div className="">{renderInputField(rowData, "night_wage", "Night Wage", options.rowIndex)}</div>
                          </>
                        )}
                      </div>
                    )}
                  />

                  <Column
                    header="Working Hours"
                    body={(rowData, options) => (
                      <div className="flex flex-column gap-">
                        {/* Day Hours */}
                        {rowData?.is_salary === false ? (
                          <>
                            <div className="">{renderInputField(rowData, "working_hour", "Day Hours", options.rowIndex, !!errors[rowData.id])}</div>
                          </>
                        ) : (
                          "-"
                        )}
                        {/* {renderInputField(rowData, "working_hour", "Day Hours", options.rowIndex, !!errors[rowData.id])} */}

                        {/* Night Hours */}
                        {rowData?.wage_night != null && rowData.wage_night != "0" && (
                          <>
                            <hr />
                            <div className="">{renderInputField(rowData, "night_hours", "Night Hours", options.rowIndex)}</div>
                          </>
                        )}
                      </div>
                    )}
                  />

                  <Column
                    header="OverTime Pay"
                    body={(rowData, options) => (
                      <div className="flex flex-column gap-">
                        {/* Day Hours */}
                        {/* {renderInputField(rowData, "overtime_value", "Enter Overtime Pay ", options.rowIndex)} */}
                        {rowData?.is_salary === true ? (
                          <>
                            <div>{renderInputField(rowData, "overtime", "Overtime Pay", options.rowIndex)}</div>
                          </>
                        ) : (
                          <>
                            {renderInputField(rowData, "overtime_value", "Enter Overtime Pay ", options.rowIndex)}
                          </>
                        )}
                        {/* Night Hours */}
                        {rowData?.wage_night != null && rowData.wage_night != "0" && (
                          <>
                            <hr />
                            <div>{renderInputField(rowData, "overtime_night_value", "Night Overtime Pay", options.rowIndex)}</div>
                          </>
                        )}
                      </div>
                    )}
                  />

                  <Column
                    header="OverTime Double Pay"
                    body={(rowData, options) => (
                      <div className="flex flex-column gap-">
                        {/* Day Hours */}
                        {/* {renderInputField(rowData, "overtime_2_value", "Enter Overtime Pay ", options.rowIndex)} */}
                        {rowData?.is_salary === true ? (
                          <>
                            <div>{renderInputField(rowData, "overtime_2", "Overtime Double Pay", options.rowIndex)}</div>
                          </>
                        ) : (
                          <>
                            {renderInputField(rowData, "overtime_2_value", "Enter Overtime Pay ", options.rowIndex)}
                          </>
                        )}

                        {/* Night Hours */}
                        {rowData?.wage_night != null && rowData.wage_night != "0" && (
                          <>
                            <hr />
                            <div className="">
                              {renderInputField(rowData, "overtime_2_night_value", "Night Overtime Double Pay", options.rowIndex)}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  />

                  {!isMobile && timePeriod.holiday_status === 1 && (
                    <Column
                      header="Stat Holiday"
                      body={(rowData, options) => (
                        <div className="flex flex-column gap-">
                          {/* Day Hours */}
                          {/* {renderInputField(rowData, "holiday_hour", "Enter Stat Holiday", options.rowIndex)} */}
                          {rowData?.is_salary === true ? (
                            <>
                              <div>{renderInputField(rowData, "holiday_Salary", "Enter Stat Holiday", options.rowIndex)}</div>
                            </>
                          ) : (
                            <>
                              {renderInputField(rowData, "holiday_hour", "Enter Stat Holiday", options.rowIndex)}
                            </>
                          )}

                          {/* Night Hours */}
                          {rowData?.wage_night != null && rowData.wage_night != "0" && (
                            <>
                              <hr />
                              <div className="">{renderInputField(rowData, "holiday_night_hour", "Night Stat Holiday", options.rowIndex)}</div>
                            </>
                          )}
                        </div>
                      )}
                    />
                  )}

                  <Column
                    header="Stat Working Holiday"
                    body={(rowData, options) => (
                      <div className="flex flex-column gap-">
                        {/* Day Hours */}
                        {/* {renderInputField(rowData, "state_holiday_value", "Enter Holiday", options.rowIndex)} */}
                        {rowData?.is_salary === true ? (
                          <>
                            <div>{renderInputField(rowData, "stat_holiday", "Enter Holiday", options.rowIndex)}</div>
                          </>
                        ) : (
                          <>
                            {renderInputField(rowData, "state_holiday_value", "Enter Holiday", options.rowIndex)}
                          </>
                        )}

                        {/* Night Hours */}
                        {rowData?.wage_night != null && rowData.wage_night != "0" && (
                          <>
                            <hr />
                            <div className="">
                              {renderInputField(rowData, "stat_working_night_value", "Night Stat Working Holiday", options.rowIndex)}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  />

                  {isMobile && (
                    <Column
                      header="Action"
                      body={(rowData) => <Button icon="pi pi-plus" onClick={() => addEditEmployeeWorkingHourData(rowData)} />}
                    />
                  )}

                  {!isMobile && (
                    <Column
                      header="Vacation Payout"
                      body={(rowData, options) => renderInputField(rowData, "vacation_payout", "Enter Vacation Payout ", options.rowIndex)}
                    />
                  )}

                  {!isMobile && (
                    <Column header="Bonus" body={(rowData, options) => renderInputField(rowData, "bonus", "Enter bonus", options.rowIndex)} />
                  )}

                  {!isMobile && (
                    <Column
                      header="Commission"
                      body={(rowData, options) => renderInputField(rowData, "commission", "Enter commission", options.rowIndex)}
                    />
                  )}

                  {!isMobile && (
                    <Column
                      header="Health Benefit"
                      body={(rowData, options) => renderInputField(rowData, "medical_exemption", "Enter Medical Exemption", options.rowIndex)}
                    />
                  )}

                  {!isMobile && (
                    <Column header="Tips" body={(rowData, options) => renderInputField(rowData, "tip", "Enter Tips", options.rowIndex)} />
                  )}
                </DataTable>

                <div className="flex flex-wrap gap-2 mt-4 md:gap-3 justify-content-end align-items-center">
                  <Button
                    type="button"
                    icon="pi pi-eye"
                    label="Preview"
                    className="p-button-info"
                    onClick={() => submitOrPreviewPaystub("preview")}
                    disabled={disableBtn || timePeriod?.payment_status === true}
                    loading={previewLoading}
                  />
                  <Button
                    type="button"
                    label="Cancel"
                    icon="pi pi-times"
                    className="p-button-secondary"
                    disabled={disableBtn || timePeriod?.payment_status === true}
                    onClick={() => {
                      if (userRole === "Client") {
                        navigate("/pay-cycle");
                      } else if (userRole === "User") {
                        const safeClientId = client_id ?? "";
                        navigate(`/pay-cycle/${btoa(safeClientId)}`);
                      }
                    }}
                  />
                  <Button
                    type="button"
                    icon="pi pi-check"
                    label="Submit"
                    className="p-button p-component common-primary-button"
                    onClick={() => submitOrPreviewPaystub("submit")}
                    disabled={disableBtn || !timePeriod?.client_charge || timePeriod?.payment_status === true}
                    loading={submitLoading}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Preview sidebar version 2 */}
      {employeeDataListPreview.length >= 0 && (
        <SalaryPreviewVersion2Client
          visible={previewVisibleVersion2}
          onHide={() => setPreviewVisibleVersion2(false)}
          onSubmit={submitOrPreviewPaystub}
          timePeriod={timePeriod}
          submitLoading={submitLoading}
          employeeDataPreview={employeeDataListPreview}
          globalHours={globalHours}
          userData={userData}
          clientData={clientData}
          client_id={client_id}
          paycycle_id={paycycle_id}
        />
      )}

      {/* add Employee working hour  */}

      <Dialog
        visible={addWorkingHourEmployeeDialog}
        maximized
        className="mx-3 lg:mx-0 add-working-hour-model"
        draggable={false}
        header="Add/Edit Employee Working Hour"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Save" icon="pi pi-check" className="common-edit-btn" onClick={hideAddWorkingHourEmployeeDialog} loading={submitLoading} />
          </div>
        }
        onHide={hideAddWorkingHourEmployeeDialog}
      >
        {selectedEmployee && (
          <div className="dialog-layout">
            {/* Employee Name */}
            <h5 className="text-center mb-2">
              Employee Name: {selectedEmployee.first_name} {selectedEmployee.last_name}
            </h5>

            {/* SINGLE SCROLL CONTAINER */}
            <div className="dialog-scroll-body">
              {/* Common fields (always scrollable) */}
              <EmployeeAdditionalPayGrid
                hours={globalHours[selectedEmployee.id]}
                onChange={handleDialogChange}
                selectedEmployee={selectedEmployee}
                timePeriod={timePeriod}
              />
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
};

export default AddWorkingHours;
